<template>
  <div>
    <b-row v-if="application !== null">
      <b-col cols="12">
        <b-row class="mx-auto my-2">
          <b-col cols="12 p-0">
            <table class="min-w-full leading-normal mt-1 text-gray" style="border: solid 1px #dedede;">
              <thead>
              <tr class="bg-gray-pale">
                <td colspan="12" class="px-2 py-2">CopyrightAssignmentTransfer Details</td>
              </tr>
              <tr>
                <th class="px-2 py-1">Tracking Number</th>
                <th class="px-2 py-1">Title</th>
                <th class="px-2 py-1">Description</th>
                <th class="px-2 py-1">Is Derivative</th>
                <th class="px-2 py-1">Status</th>
              </tr>
              </thead>
              <tbody>
              <tr style="border: solid 1px #dedede;" >
                <td class="px-2 py-1 font-bold text-gray">
                  <span class="">{{ application.trackingNumber || application.trackingNo }}</span>
                </td>
                <td class="px-2 py-1">
                  <span class="text-gray text-capitalize">{{ application.title || application.newName }}</span>
                </td>
                <td class="px-2 py-1">
                  <span class="text-gray">{{ getDescription(application.description) }}</span>
                </td>
                <td class="px-2 py-1">
                  <span class="text-gray">{{ isDerivative(application.isDerivativeWork) }}</span>
                </td>
                <td class="px-2 py-1">
                  <span :class="statusColorCode(application.status)">{{statusDataInfo(application.status)}}</span>
                </td>
              </tr>
              </tbody>
            </table>
          </b-col>
        </b-row>
      </b-col>
    </b-row>
  </div>
</template>
 
<script>
import moment from "moment";
 
export default {
  name: "CopyrightAssignmentTransferFormsEscalated",
  props:{
    application: {
      type: [Object, null],
      default: null,
    }
  },
  data(){
    return{
      hasComments: false,
      currentRoute: "form",
      selectedId:null,
      margin:"2px",
      hasContent:false,
    }
  },
  methods:{
    isDerivative(val) {
      if (typeof val === 'object' && val !== null) {
        return val.Valid && val.Bool ? 'Yes' : 'No';
      }
      return val ? 'Yes' : 'No';
    },
    getDescription(val) {
      if (typeof val === 'object' && val !== null) {
        return val.Valid ? val.String : '';
      }
      return val || '';
    },
    statusDataInfo(status) {
      if (!status) return "";
      if (status.toUpperCase() === "APPROVED") {
        return "Approved"
      } else if (status.toUpperCase() === "RESERVED") {
        return "Reserved"
      } else if (status.toUpperCase() === "QUERIED") {
        return "Issues Raised"
      } else if (status.toUpperCase() === "ASSIGNED") {
        return "Being Processed"
      } else if (status.toUpperCase() === "PENDING") {
        return "Submitted"
      } else if (status.toUpperCase() === "APPEALED") {
        return "Appealed"
      }else if (status.toUpperCase() === "REJECTED") {
        return "Rejected"
      }else if (status.toUpperCase() === "DRAFT") {
        return "Draft"
      } else if (status.toUpperCase() === "AWAITING_PAYMENT_CONFIRMATION") {
        return "Confirming Payment"
      }else if (status.toUpperCase() === "PAYMENT_FAILED") {
        return "Payment Failed"
      }
      return status;
    },
    statusColorCode(status) {
      if (!status) return "";
      if (status.toUpperCase() === "APPROVED" || status.toUpperCase() === "RESERVED") {
        return "text-green"
      } else if (status.toUpperCase() === "QUERIED") {
        return "text-orange"
      } else if (status.toUpperCase() === "ASSIGNED") {
        return "text-blue"
      } else if (status.toUpperCase() === "PENDING") {
        return "text-gray"
      } else if (status.toUpperCase() === "APPEALED" ) {
        return "text-red"
      }else if (status.toUpperCase() === "REJECTED") {
        return "text-red"
      }else if (status.toUpperCase() === "DRAFT") {
        return "text-gray"
      } else if (status.toUpperCase() === "AWAITING_PAYMENT_CONFIRMATION") {
        return "text-purple"
      }else if (status.toUpperCase() === "PAYMENT_FAILED") {
        return "text-red"
      }
      return "";
    },
    dateFormat(date){
      return moment(date).format("DD-MM-YYYY")
    },
  },
}
</script>

<style scoped>
th, td{
  font-size: 12px;
}
</style>
